import { Component, Input, Type } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Route, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { CookieService } from 'ngx-cookie-service';
import { async, map, tap } from 'rxjs';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { SpinnerServiceService } from '../../serviceSpinner/spinner-service.service';
import { config } from 'src/app/config/api.config';
import { PlateformeLMSService } from 'src/app/modules/plateforme-lms/services/plateforme-lms.service';
import { ProgrammeCoursera } from 'src/app/model/programme-coursera';
import { SideBarAprennantComponent } from './side-bar-apprennant/side-bar-apprenant.component';
import { SideBarApprenantStemdComponent } from './side-bar-apprenant-stemd/side-bar-apprenant-stemd.component';
import { SideBarGestionnaireComponent } from './side-bar-gestionnaire/side-bar-gestionnaire.component';
import { SideBarAdminComponent } from './side-bar-admin/side-bar-admin.component';
import { SideBarMentorComponent } from './side-bar-mentor/side-bar-mentor.component';
import { SideBarMentorStemdComponent } from './side-bar-mentor-stemd/side-bar-mentor-stemd.component';
import { SideBarPersonelCompanyComponent } from './side-bar-personel-company/side-bar-personel-company.component';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { environment } from 'src/environments/environments';
import { ca, th } from 'date-fns/locale';
import { SideBarHorsFormationComponent } from './side-bar-hors-formation/side-bar-hors-formation.component';
import { SideBarPartnerComponent } from './side-bar-partner/side-bar-partner.component';
import { SideBarGestionnaireBeninComponent } from './side-bar-gestionnaire-benin/side-bar-gestionnaire-benin.component';
import { SideBarMentorFccComponent } from './side-bar-mentor-fcc/side-bar-mentor-fcc.component';
import { SideBarResponsableCertificatFccComponent } from './side-bar-responsable-certificat-fcc/side-bar-responsable-certificat-fcc.component';
import { SideBarFinanceBeninComponent } from './side-bar-finance-benin/side-bar-finance-benin.component';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class SideBarComponent {
  token: any;
  profil: any;
  logged: any;
  user: any | null;
  email!: string;
  fullname!: string;
  role!: any;
  roleBenin!: any;
  isAdmin: boolean = false;
  eleve: boolean = false;
  nomrole!: string;
  hidden: boolean = false;
  hiddenLms: boolean = false;
  hiddenSIG: boolean = false;
  hiddenhors_SIG: boolean = false;
  hiddenPPP: boolean = false;
  cohorte!: string;
  horsParcours: string = 'HP-2412'; //Attribut pour savoir si la personne est dans un ceetificat hors-parcours

  hiddenHS: boolean = false;

  iuf: any;
  coursera_user: boolean = false;
  isPersonalCompany: boolean = false;
  isFcc: boolean = false;
  ifFccBenin: boolean = false;
  isAipen: boolean = false;
  isAdminFcc: boolean = false;
  isEleve: boolean = false;
  isCourseraStudent: boolean = false;
  isAdminAipen: boolean = false;
  isCom: boolean = false;
  isAdminCom: boolean = false;
  isAdminSuivi: boolean = false;
  isAdminFinance: boolean = false;
  isStemd: boolean = false;
  isBoard: boolean = false;
  isSEV: boolean = false;
  isFinance: boolean = false;
  isFinanceBenin: boolean = false;
  isStudentStemd: boolean = false;
  isChefEtab: boolean = false;
  isMentor: boolean = false;
  isOffTrackStudent: boolean = false;
  urlScholarVox = 'https://skills.scholarvox.com/forcen';
  urlProgramme: string = '';
  progClasseA: string =
    'https://www.coursera.org/career-academy/programs/career-academy-campus-learning-program-836mn?authMode=login&authProvider=universite-numerique-cheikh-hamidou-kane';
  progClasseB: string =
    'https://www.coursera.org/career-academy/programs/alumni-career-academy-learning-program-0tynr?authMode=login&authProvider=universite-numerique-cheikh-hamidou-kane';
  urlCoursera: string =
    'https://www.coursera.org/programs/career-academy-campus-learning-program-836mn/my-learning?authProvider=universite-numerique-cheikh-hamidou-kane&myLearningTab=IN_PROGRESS';
  parcours3: string = 'SIG2412-FODE';
  parcours4: string = 'SIG2502-FODE';
  cohortesPPP: string[] = ['SIG2412-FODE', 'SIG2502-FODE'];
  urlPlateformeScience = 'https://sciences.force-n.sn/auth/oidc';

  // cohorteOption = [
  //   { name: '', label: '' },
  //   { name: 'HSIG2502_FODE', label: 'HSIG2502-FODE' },
  // ];

  urlPpp: string = 'https://formation.force-n.sn/course/view.php?id=620';
  urlSoftSkills: string =
    'https://formation.force-n.sn/course/view.php?id=1239';
  hideDashboard: boolean = true;
  isVCN: boolean = false;
  isAMI: boolean = false;
  isMentorFCC: boolean = false;
  VCNCohorte: string = 'VCN2509-FODE';
  isPartnerHaske: boolean = false;
  isCoachHaske: boolean = false;
  isMembreJury: boolean = false;
  isPointFocal: boolean = false;
  isPartnerCoach: boolean = false;
  isResponsableCertificatFCC: boolean = false;

  currentComponent!: Type<any>;
  constructor(
    private backapi: BackendApiService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private keycloak: KeycloakService,
    private spinnerService: SpinnerServiceService,
    private plateformeLMSService: PlateformeLMSService,
  ) {
    this.keycloak
      .isLoggedIn()
      .then(async (value) => {
        if (value) {
          this.backapi
            .getBeneficiaryByEmail(
              (await this.keycloak.loadUserProfile()).email,
            )
            .pipe()
            .subscribe({
              next: (response) => {
                sessionStorage.setItem('user', JSON.stringify(response));
                sessionStorage.setItem('logged', 'true');

                this.user = sessionStorage.getItem('user');
                //console.log('side bar :', this.user);
                // console.log('side bar :', this.user);
                this.logged = sessionStorage.getItem('logged');
                this.profil = JSON.parse(this.user).profile.id;
                // console.log('Le profil : ', this.profil);
                this.email = JSON.parse(this.user).email;
                sessionStorage.setItem('iuf', JSON.parse(this.user).iuf);
                this.iuf = JSON.parse(this.user).iuf;

                this.fullname =
                  JSON.parse(this.user).lastname +
                  ' ' +
                  JSON.parse(this.user).firstname;
                this.profil = JSON.parse(this.user).profile.id;
                this.role = JSON.parse(this.user)?.roles;
                this.roleBenin = JSON.parse(this.user).roles[0]?.roleName;
                console.log('Beninnn', this.roleBenin);
                this.cohorte = JSON.parse(
                  this.user,
                ).beneficiaryCohortes[0]?.cohorte.cohorteName;
                // console.log('User connecte PPP:', JSON.parse(this.user));
                // console.log("La cohorte de l'apprenant : ", this.cohorte);
                /*****HORS PARCOURS CHECK*********/
                if (JSON.parse(this.user)?.offTrackList.length > 0) {
                  // console.log(
                  //   'is hors parcours: ',
                  //   JSON.parse(this.user)?.offTrackList.length
                  // );
                  this.isOffTrackStudent = true;
                }
                if (
                  JSON.parse(this.user)?.citizenNumericVacationList.length > 0
                ) {
                  this.isVCN = true;
                }

                // Appeler checkFirstAccessPPP après avoir défini iuf et cohorte
                // console.log('verifffffff', this.iuf, this.cohorte);
                this.cohortesPPP.forEach((cohorte) => {
                  // console.log('la cohorte 1', this.cohorte);

                  if (cohorte === this.cohorte) {
                    // console.log('la cohorte L', cohorte);
                    this.checkFirstAccessPPP(this.iuf, cohorte);
                  }
                });

                if (this.role.length > 0) {
                  this.role.forEach(
                    (element: { id: number; roleName: any }) => {
                      this.nomrole = element.roleName;
                      sessionStorage.setItem('nomrole', this.nomrole);
                      // console.log('ROLE ' + this.nomrole);
                      switch (element.roleName) {
                        case 'admin': {
                          this.isAdmin = true; //Administrateur
                          break;
                        }

                        case 'gestionnaire': {
                          this.isFcc = true; // Gestionnaire FCC
                          break;
                        }

                        case 'gestionnaire-fcc-benin': {
                          this.ifFccBenin = true; // Gestionnaire benin
                          break;
                        }

                        case 'board': {
                          this.isBoard = true; // Programme Board
                          break;
                        }
                        case 'suivi': {
                          this.isSEV = true; // Gestionnaire Suivi Evaluation
                          break;
                        }
                        case 'finance': {
                          this.isFinance = true; //Gestionnaire Finance
                          break;
                        }
                        case 'etudiant_stemd': {
                          this.isStudentStemd = true; //Etudiant STEMD
                          break;
                        }
                        case 'chefetablissement_stemd': {
                          this.isChefEtab = true; //Chef Etablissement STEMD
                          break;
                        }
                        case 'personal-company': {
                          this.isPersonalCompany = true;
                          break;
                        }
                        case 'mentor': {
                          this.isMentor = true; //Mentor
                          break;
                        }
                        case 'aipen': {
                          this.isAipen = true; //Gestionnaire AIPEN
                          break;
                        }
                        case 'eleve': {
                          this.isEleve = true; //Eleve
                          break;
                        }
                        case 'admin-fcc': {
                          this.isAdminFcc = true; //Administrateur FCC
                          break;
                        }

                        case 'stemd': {
                          this.isStemd = true; //Gestionnaire Stemd
                          break;
                        }

                        case 'admin-aipen': {
                          this.isAdminAipen = true; //Administrateur Aipen
                          break;
                        }

                        case 'admin-com': {
                          this.isAdminCom = true; //Administrateur Com
                          break;
                        }
                        case 'admin-suivi': {
                          this.isAdminSuivi = true; //Administrateur Suivi
                          break;
                        }
                        case 'admin-finance': {
                          this.isAdminFinance = true; //Administrateur Finance
                          break;
                        }

                        case 'com': {
                          this.isCom = true; //Gestionnaire Com
                          break;
                        }

                        case 'coursera_srudent': {
                          this.isCourseraStudent = true; //Apprenant Coursera
                          break;
                        }
                        case 'ami': {
                          this.isAMI = true;
                          break;
                        }
                        case 'partner-haske': {
                          this.isPartnerHaske = true;
                          break;
                        }
                        case 'coach-haske': {
                          this.isCoachHaske = true;
                          break;
                        }
                        case 'point-focal': {
                          this.isPointFocal = true;
                          break;
                        }
                        case 'membre-jury': {
                          this.isMembreJury = true;
                          break;
                        }
                        case 'partner-coach': {
                          this.isPartnerCoach = true;
                          break;
                        }
                        case 'mentor-fcc': {
                          this.isMentorFCC = true;
                          break;
                        }
                        case 'responsable-certificat': {
                          this.isResponsableCertificatFCC = true;
                          break;
                        }
                        case 'gestionnaire-finance-benin': {
                          this.isFinanceBenin = true; // Gestionnaire Finance Benin
                          break;
                        }
                      }
                    },
                  );
                  // console.log(
                  //   "le profil de l'apprenant xxxxxx : ",
                  //   this.profil
                  // );
                }

                if (this.coursera_user && this.iuf) {
                  //Configuration du coursera
                  this.initCourseraObservable(this.iuf);
                }
                this.spinnerService.hideSpinner();
                const currentRoute = this.router.url;
                this.router
                  .navigateByUrl('/', { skipLocationChange: true })
                  .then(() => {
                    this.router.navigate([currentRoute]);
                  });
                if (
                  (this.isAdmin ||
                    this.isAdminAipen ||
                    this.isAdminCom ||
                    this.isAdminFcc ||
                    this.isAdminFcc ||
                    this.isAdminFinance ||
                    this.isAdminSuivi) &&
                  this.profil == 4 &&
                  this.logged == 'true'
                ) {
                  this.currentComponent = SideBarAdminComponent;
                  this.hideDashboard = false;
                } else if (this.isPersonalCompany && this.profil == 3) {
                  this.currentComponent = SideBarPersonelCompanyComponent;
                } else if (
                  this.ifFccBenin &&
                  this.roleBenin == 'gestionnaire-fcc-benin' &&
                  this.logged == 'true' &&
                  this.profil == 4
                ) {
                  this.currentComponent = SideBarGestionnaireBeninComponent;
                  this.hideDashboard = true;
                } else if (
                  (this.isAipen ||
                    this.isCom ||
                    this.isFinance ||
                    this.isFcc ||
                    this.isSEV ||
                    this.isBoard ||
                    this.isStemd) &&
                  this.logged == 'true' &&
                  this.profil == 4
                ) {
                  this.currentComponent = SideBarGestionnaireComponent;
                } else if (this.isMentor) {
                  this.currentComponent = SideBarMentorComponent;
                } else if (
                  this.isEleve &&
                  this.logged == 'true' &&
                  this.profil == 1
                ) {
                  this.currentComponent = SideBarApprenantStemdComponent;
                } else if (
                  this.isVCN &&
                  !this.cohorte &&
                  !this.isCourseraStudent &&
                  !this.isAMI &&
                  this.logged === 'true' &&
                  this.profil === 1 &&
                  !this.isOffTrackStudent
                ) {
                  // console.log('iuf vcn', this.iuf, this.VCNCohorte);
                  this.plateformeLMSService
                    .firstAccess(this.iuf, this.VCNCohorte)
                    .subscribe();

                  this.currentComponent = SideBarHorsFormationComponent;
                } else if (
                  (this.coursera_user || !this.eleve) &&
                  this.logged == 'true' &&
                  this.profil == 1
                ) {
                  this.currentComponent = SideBarAprennantComponent;
                  if (this.isVCN)
                    this.plateformeLMSService
                      .firstAccess(this.iuf, this.VCNCohorte)
                      .subscribe();
                } else if (
                  this.isStudentStemd &&
                  this.logged == 'true' &&
                  this.profil == 2
                ) {
                  this.currentComponent = SideBarMentorStemdComponent;
                } else if (
                  (this.isPartnerHaske ||
                    this.isCoachHaske ||
                    this.isPointFocal ||
                    this.isMembreJury ||
                    this.isPartnerCoach) &&
                  this.logged == 'true' &&
                  this.profil == 6
                ) {
                  this.currentComponent = SideBarPartnerComponent;
                } else if (
                  this.profil == 2 &&
                  this.isMentorFCC &&
                  this.logged == 'true'
                ) {
                  this.currentComponent = SideBarMentorFccComponent;
                } else if (
                  this.profil == 4 &&
                  this.isResponsableCertificatFCC &&
                  this.logged == 'true'
                ) {
                  this.currentComponent =
                    SideBarResponsableCertificatFccComponent;
                } else if (
                  this.profil == 4 &&
                  this.logged == 'true' &&
                  this.roleBenin == 'gestionnaire-finance-benin'
                ) {
                  this.currentComponent = SideBarFinanceBeninComponent;
                } else {
                  this.router.navigateByUrl('/usernotfound');
                }
                // console.log('currentComponent: ', this.isAdmin);
              },
              error: (err: any) => {
                this.spinnerService.hideSpinner();
                this.router.navigateByUrl('/usernotfound');
              },
            });
        }
      })
      .catch((error) => {
        throw 'Error';
      });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnInit() {
    let tk = this.token;
    this.router.navigate(['dashboard/tableau-bord']);
    // console.log('user init: ', this.user);
  }

  logout() {
    sessionStorage.clear();

    window.location.href =
      'https://raagnale.force-n.sn/realms/' +
      environment.keycloak.realm +
      '/protocol/openid-connect/logout?client_id=' +
      environment.keycloak.clientId +
      '&post_logout_redirect_uri=' +
      config.redirectURI;
    // console.log('url redirection: ', config.redirectURI);
    // console.log('url redirection: ', environment.keycloak.realm);
    // console.log('url redirection: ', environment.keycloak.clientId);
  }

  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }

  sessionChange2(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidaturesHS/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidaturesHS/' + cohorte);
    }, 500);
  }

  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }

  hideCollapseHS() {
    this.hiddenHS = !this.hiddenHS;
  }

  hideCollapse() {
    this.hidden = !this.hidden;
  }

  hideCollapseLms() {
    this.hiddenLms = !this.hiddenLms;
  }

  hideCollapseSIG() {
    this.hiddenSIG = !this.hiddenSIG;
  }
  hideCollapseHORS_SIG() {
    this.hiddenhors_SIG = !this.hiddenhors_SIG;
  }
  hideCollapsePPP() {
    this.hiddenPPP = !this.hiddenPPP;
  }

  initCourseraObservable(iuf: string) {
    this.plateformeLMSService
      .getCourseraByIUF(iuf)
      .pipe(
        tap((coursera) => {
          // console.log('coursera :', coursera);
          if (coursera != null) {
            //check first access
            if (!coursera.firstAccess) {
              this.plateformeLMSService
                .checkFirstAccess(this.iuf)
                .pipe(
                  tap((check) => {
                    // console.log('status firstAccess: ', check);
                  }),
                )
                .subscribe();
            }
            if (
              coursera.programmeCoursera === ProgrammeCoursera.PROGR_CLASSE_A
            ) {
              this.urlProgramme = this.progClasseA;
              // console.log('url : ', this.urlProgramme);
            } else if (
              coursera.programmeCoursera === ProgrammeCoursera.PROGR_CLASSE_B
            ) {
              this.urlProgramme = this.progClasseB;
              // console.log('url : ', this.urlProgramme);
            }
          }
        }),
      )
      .subscribe();
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  checkFirstAccessPPP(iuf: string, cohorte: string) {
    // console.log('verikkk', this.iuf, this.cohorte);

    this.plateformeLMSService.chekcFirstAccesPPP(iuf, cohorte).subscribe(
      (response) => {
        if (response.status == 200) {
          // console.log('Succès :', response.message);
        } else {
          // console.error('Error', response.message);
        }
      },
      (error) => {
        // console.error('Erreur inattendue :', error);
      },
    );
  }
  // Créez un tableau pour suivre l'état de chaque collapse
  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }
}
